import { api } from "@/lib/api";
import type { CreateDissertationData } from "./dissertation.schema";

type DissertationFile = {
	name: string;
	path: string;
};

const appendDissertationFormData = (formData: FormData, data: CreateDissertationData) => {
	formData.append("title", data.title);
	formData.append("abstract", data.abstract);

	if (data.dissertation_docx) {
		formData.append("dissertation_docx", data.dissertation_docx);
	}
	if (data.dissertation_file) {
		formData.append("dissertation_file", data.dissertation_file);
	}
	if (data.proposal_file) {
		formData.append("proposal_file", data.proposal_file);
	}
	if (data.cover_letter_file) {
		formData.append("cover_letter_file", data.cover_letter_file);
	}
	if (data.turnitin_score_file) {
		formData.append("turnitin_score_file", data.turnitin_score_file);
	}
};

// API Endpoints
export const createDissertation = async (data: CreateDissertationData) => {
	const formData = new FormData();
	appendDissertationFormData(formData, data);

	const response = await api.post("/dissertations", formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});

	return response.data;
};

export const postComment = async (formData: FormData) => {
	const res = await api.post(`/dissertations/feedback`, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});
	return res.data;
}

export const getDissertation = async () => {
	const response = await api.get("/dissertations/retrieve");
	return response.data;
};

export const getDissertationFiles = async (): Promise<{ data: DissertationFile[] }> => {
	const response = await api.get("/dissertations/files");
	return {
		...response.data,
		data: Object.values(response.data?.data ?? {}) as DissertationFile[],
	};
};

export const resubmitDissertation = async (dissertationKey: string, data: CreateDissertationData) => {
	const formData = new FormData();
	appendDissertationFormData(formData, data);

	const response = await api.post(`/dissertations/${dissertationKey}/resubmit`, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});

	return response.data;
};

export const submitFinalDissertation = async (dissertationKey: string, files: { pdf: File; docx?: File }) => {
	const formData = new FormData();
	formData.append("final_dissertation_file", files.pdf);

	if (files.docx) {
		formData.append("final_dissertation_docx", files.docx);
	}

	const response = await api.post(`/dissertations/${dissertationKey}/final-submission`, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});

	return response.data;
};
